import { useContext, useState } from 'react';
import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

import PaymentsData from './PaymentsData';

import { PaymentsStateContext } from './PaymentsContextProvider';

const INITIAL_PAYMENT_RECEIPT_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_MEET_RESULTS_CART_ITEM_STATE = {
  ...BASIC_INITIAL_STATE
};

const usePaymentsData = () => {
  const [paymentsState, setPaymentsState] = useContext(PaymentsStateContext);
  const [paymentReceiptState, setPaymentReceiptState] = useState(INITIAL_PAYMENT_RECEIPT_STATE);
  const [cartCountState, setCartCountState] = useState({});
  const [meetResultsCartItemState, setMeetResultsCartItemState] = useState(INITIAL_MEET_RESULTS_CART_ITEM_STATE);

  const getPaymentReceipt = (receiptNumber) => {
    return PaymentsData.getPaymentReceiptData(receiptNumber, paymentReceiptState, setPaymentReceiptState);
  };

  const getCartCount = (orgUnitId, itemSubsystemId, itemContract, referenceId) => {
    return PaymentsData.getCartCountData(orgUnitId, itemSubsystemId, itemContract, referenceId, cartCountState, setCartCountState);
  };

  const setCartChanged = (cartChanged) => {
    setPaymentsState({
      ...paymentsState,
      cartChanged
    });
  };

  const deleteMeetResultsCartItem = (meetId) => {
    return PaymentsData.deleteMeetResultsCartItemData(meetId, meetResultsCartItemState, setMeetResultsCartItemState);
  };

  const resetPaymentsReceiptState = () => {
    setPaymentReceiptState(INITIAL_PAYMENT_RECEIPT_STATE);
  };

  const resetMeetResultsCartItemState = () => {
    setMeetResultsCartItemState(INITIAL_MEET_RESULTS_CART_ITEM_STATE);
  };

  return {
    cartChanged: paymentsState.cartChanged === true,
    paymentsState,
    cartCountState,
    paymentReceiptState,
    meetResultsCartItemState,
    getPaymentReceipt,
    getCartCount,
    deleteMeetResultsCartItem,
    setCartChanged,
    resetPaymentsReceiptState,
    resetMeetResultsCartItemState
  };
};

export default usePaymentsData;